import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Select, Form, Button, Input, Upload, message, Typography, Icon, Card, Breadcrumb, Radio, Divider, Tabs, DatePicker } from 'antd';
import { getStaticProTime, getStaticProList, getStaticFinishPer, getStaticProTaskOrMember, getStaticProRealInfo, getStaticProFinishPro, getStaticProExpiryRate, getStaticProOrTaskInfo } from '@/api/api';
import moment from 'moment';
import echarts from 'echarts';
import utils from '@/api/util';
import './statistical.css';
import servers from '@/api/server';

const FormItem = Form.Item;
const Option = Select.Option;
const { TabPane } = Tabs;
const { Text, Title } = Typography;
const RangePicker = DatePicker.RangePicker;

let mutiPro_cavans, singlePro_cavans, expiry_cavans, proOrTask_cavans;

class Statistic_project extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            pro_tab: 1,
            dueStat_tab: 1,
            proList: [],
            proIds: [],
            proIds_2: [],
            proNum: 0,
            jobNum: 0,
            userNum: 0,
            ch_Width: '',
            expiryJobPer: 0,
            expiryProPer: 0,
            compEcharts_flag: true,
            prosEcharts_flag: true,
            noFinishTaskArr: []
        }
        // this.getProList = this.getProList.bind(this);
        // this.statistic_proChange = this.statistic_proChange.bind(this);
        // this.finishPerHandle = this.finishPerHandle.bind(this);
        // this.comprehensiveSwitch = this.comprehensiveSwitch.bind(this);
        // this.getProUpdate=this.getProUpdate.bind(this);
        // this.taskOrMemberHandle = this.taskOrMemberHandle.bind(this)
        // this.taskOrMember = this.taskOrMember.bind(this);
        // this.materialCostHandle = this.materialCostHandle.bind(this);
        // this.finishProgressHandle = this.finishProgressHandle.bind(this);
        // this.proIdsChange = this.proIdsChange.bind(this);
        // this.getProOrTaskInfoData=this.getProOrTaskInfoData.bind(this);
        this.getExpiryRate = this.getExpiryRate.bind(this);//2
        this.expiryMenuSwitch = this.expiryMenuSwitch.bind(this);//2
        this.expiryRangeChange = this.expiryRangeChange.bind(this)
    }

    componentDidMount() {
        // mutiPro_cavans = echarts.init(document.getElementById('pro_progress_echarts'));
        // singlePro_cavans = echarts.init(document.getElementById('comprehensiveStat'));
        expiry_cavans = echarts.init(document.getElementById('dueStat'));//2
        // proOrTask_cavans = echarts.init(document.getElementById('proOrTaskInfo'));
        // mutiPro_cavans.showLoading();
        expiry_cavans.showLoading();//2
        // singlePro_cavans.showLoading()
        let nowTime = (new Date()).getTime();
        let nowDate = utils.formatTimestamp(nowTime, 'date');
        let nowMonth = utils.formatTimestamp(nowTime, 'yearMonth');
        // this.getProList()
        // this.getProUpdate();
        // this.pro_taskOrMember();
        this.getExpiryRate({
            type: 1,
        }) //2
        // this.finishPerHandle({})
        // this.getProOrTaskInfoData({})
    }




    // 项目过期率/任务过期率时间段更改
    expiryRangeChange(value, mode) {
        const that = this;
        // if(value[0] > moment() || value[1] > moment()){
        //     message.error('不能选择未来时间',2);
        //     return
        // };
        that.setState({
            expiryRange: value
        });
        this.getExpiryRate({
            type: that.state.dueStat_tab,
            beginTime: value[0].format('YYYYMM'),
            endTime: value[1].format('YYYYMM')
        })
    }

    // 项目过期率/任务过期率切换  //2
    expiryMenuSwitch(e) {
        const that = this;
        this.setState({ dueStat_tab: e.target.value });
        this.getExpiryRate({
            type: e.target.value,
            beginTime: that.state.expiryRange ? that.state.expiryRange[0].format('YYYYMM') : '',
            endTime: that.state.expiryRange ? that.state.expiryRange[1].format('YYYYMM') : '',
        })
    }

    // 项目过期率/任务过期率数据获取 //2
    getExpiryRate(params = {}) {
        const that = this;
        expiry_cavans.showLoading()
        getStaticProExpiryRate(params, res => {
            console.log(res);
            if (res.statusCode !== 1000) {
                return
            };
            that.setState({
                expiryJobPer: res.jobPer,
                expiryProPer: res.proPer
            });
            that.expiryCanvas(res, that.state.dueStat_tab)
        }, err => {
            console.log(err)
        })
    }

    // 项目过期率/任务过期率数据图标绘制 //2
    expiryCanvas(values, flag) {
        const that = this;
        expiry_cavans.clear();
        expiry_cavans.setOption({
            title: {
                text: flag === 1 ? '课题项目过期情况' : '任务过期情况',
                subtext: '',
                x: 'center'
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: values.time
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: (value, index) => {
                        return (value * 100) + '%'
                    }
                }
            },
            series: [{
                data: values.per,
                type: 'line',
                markLine: {
                    data: [
                        { type: 'average', name: '平均值' }
                    ],
                    label: {
                        formatter: (params) => {
                            return '平均过期率:' + parseFloat(params.value) * 100 + '%'
                        }
                    }
                },
                label: {
                    show: true,
                    formatter: (params) => {
                        return (parseFloat(params.value) * 100).toFixed(1) + '%'
                    }
                },
            }]
        });
        expiry_cavans.hideLoading()

    }




    render() {
        const that = this;
        const { userNum, ch_Width, noFinishTaskArr, jobNum, proNum, proList, proIds, expiryJobPer, expiryProPer, proIds_2, compEcharts_flag, prosEcharts_flag } = this.state;
        return (
            <div className="statistic">
                <Card
                    title={
                        <div className="pr">
                            <Text strong className="mr5" style={{ fontSize: '15px' }}><i className="iconfont icon-tongji c_8bff mr5 vm"></i>课题项目过期率</Text>
                            <RangePicker
                                format="YYYY-MM"
                                mode={['month', 'month']}
                                showTime={false}
                                style={{ width: '240px' }}
                                onPanelChange={(value, mode) => this.expiryRangeChange(value, mode)}
                                value={that.state.expiryRange}
                                className="pa_rm"
                            />
                        </div>
                    }
                    className="statistic_panel"
                >
                    {/* <div className="statistic_pro_dueStat">
                        <div className="module_item">
                            <p>整体项目过期率</p>
                            <h3><b style={{ fontSize: '36px' }}>{expiryProPer && (parseFloat(expiryProPer) * 100).toFixed(1)}%</b></h3>
                        </div>
                        <div className="module_item">
                            <p>整体任务过期率</p>
                            <h3><b style={{ fontSize: '36px' }}>{expiryJobPer && (parseFloat(expiryJobPer) * 100).toFixed(1)}%</b></h3>
                        </div>
                    </div>
                    <Divider /> */}
                    <div className="statistic_pro_chartBox tc mt20">
                        <Radio.Group value={this.state.dueStat_tab} onChange={this.expiryMenuSwitch} style={{ marginBottom: 16 }}>
                            <Radio.Button value={1}>课题项目过期率</Radio.Button>
                            <Radio.Button value={2}>任务过期率</Radio.Button>
                        </Radio.Group>
                        <div className="statistic_pro_tabPane" id="dueStat"></div>
                    </div>
                </Card >
            </div>
        )
    }
}


export default Statistic_project;

